export const en = {
  title: 'Crush Season',
  subtitle: 'A tiny winery with extremely reasonable ambitions.',
  continue: 'Continue Vintage',
  newGame: 'New Winery',
  importSave: 'Import Save',
  exportSave: 'Export Save',
  settings: 'Settings',
  credits: 'Credits',
  privacy: 'Privacy',
  renown: 'Renown',
  legacyCorks: 'Legacy Corks',
  estate: 'Estate',
  wines: 'Wines',
  sales: 'Sales',
  cellar: 'Bottle History',
  action: 'Owner Action',
  automate: 'Hire & Automate',
  capacity: 'Expand Storage',
  prestige: 'Conclude Vintage',
  blocked: 'Output full — expand downstream storage or throughput.',
  automated: 'This station runs itself. Your action now gives 45 seconds of overdrive.',
  manual: 'The owner is still doing this by hand.',
  noSave: 'No local vintage found yet.',
  updateReady: 'A fresh build is ready.'
} as const;

export type CopyKey = keyof typeof en;
export const t = (key: CopyKey): string => en[key];
